import { createPerformableConfig, TenantId } from '~/tenants/common/registry';
import { coerceLiteralNumberRequired, FIRST_VERSION_TIMESTAMP } from '~/lib/zod';
import z from 'zod';

export default createPerformableConfig(
  'staging',
  {
    [FIRST_VERSION_TIMESTAMP]: z.object({
      version: coerceLiteralNumberRequired(FIRST_VERSION_TIMESTAMP),
      photos: z.coerce.number().min(1),
    }),
  },
  {
    name: 'Virtual Staging',
    thumbnail: 'tenant/mpi/staging/1.jpg',
    short:
      'Virtual Stating is a simple, low-cost solution for adding furniture digitally to spaces to impove online presence and help buyers to better visualize a space.',
    tenant: TenantId.MAINE_LINE_MEDIA,
    images: [],
    group: 'Photo Editing',
  },
);
